import { render, staticRenderFns } from "./FormQuestionTrueFalseType.vue?vue&type=template&id=b12180d8"
import script from "./FormQuestionTrueFalseType.vue?vue&type=script&lang=js"
export * from "./FormQuestionTrueFalseType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b12180d8')) {
      api.createRecord('b12180d8', component.options)
    } else {
      api.reload('b12180d8', component.options)
    }
    module.hot.accept("./FormQuestionTrueFalseType.vue?vue&type=template&id=b12180d8", function () {
      api.rerender('b12180d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/form/FormApp/FormQuestionTrueFalseType.vue"
export default component.exports